import { apiClient } from '@/plugins/axios';

const getExpenses = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/expenses?' + params.toString());
};

const getExpenseById = async (id: number) => {
  return apiClient.get(`/expenses/${id}`);
};

const createExpense = async (data: any) => {
  return apiClient.post('/expenses', data);
};

const updateExpense = async (id: number, data: any) => {
  return apiClient.patch(`/expenses/${id}`, data);
};

const deleteExpense = async (id: number) => {
  return apiClient.delete(`/expenses/${id}`);
};

export default {
  getExpenses,
  getExpenseById,
  createExpense,
  updateExpense,
  deleteExpense,
};
